import usePageMeta from './usePageMeta';

/**
 * Sets a branded document title for admin/Control Center pages.
 *
 * Examples:
 *   useAdminPageMeta('Dashboard')
 *     → "Dashboard · Control Center | The Elemental Embrace"
 *   useAdminPageMeta()
 *     → "Control Center | The Elemental Embrace"
 */
export default function useAdminPageMeta(section, opts = {}) {
  const titleStr = section ? `${section} · Control Center` : 'Control Center';
  usePageMeta({
    title: titleStr,
    description:
      opts.description ||
      `The Elemental Embrace — Control Center${section ? ` · ${section}` : ''}.`,
    siteName: 'The Elemental Embrace',
    type: 'website',
  });
}
